"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = exports.isActorInput = exports.generateActorSDRN = void 0;
var utils_1 = require("./utils");
function generateActorSDRN(id, realm) {
    if (realm === void 0) { realm = 'schibsted.com'; }
    return "sdrn:".concat(realm, ":user:").concat(id);
}
exports.generateActorSDRN = generateActorSDRN;
function isActorInput(input) {
    return Object.prototype.hasOwnProperty.call(input, "actor");
}
exports.isActorInput = isActorInput;
function formatActorInput(input) {
    if ((0, utils_1.isString)(input)) {
        return { id: input };
    }
    var _a = input || {}, id = _a.id, realm = _a.realm, rest = __rest(_a, ["id", "realm"]);
    return __assign({ id: id, realm: realm }, rest);
}
/**
 * Function to generate a builder for Actor objects.
 */
function actor(input) {
    var actorInput = (input || {}).actor;
    if (!actorInput) {
        return undefined;
    }
    var _a = formatActorInput(actorInput), id = _a.id, realm = _a.realm, inputProps = __rest(_a, ["id", "realm"]);
    if (!id) {
        return undefined;
    }
    var baseActor = {
        '@id': generateActorSDRN(id, realm),
        'spt:userId': generateActorSDRN(id, realm),
    };
    return Object.assign(baseActor, inputProps);
}
exports.default = actor;
var defaultValue = function () { return undefined; };
exports.defaultValue = defaultValue;
